// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__oA2YD","boxTitle":"Qualiphy_boxTitle__XmnVg","box":"Qualiphy_box__2fW8S","toggleWrap":"Qualiphy_toggleWrap__1F6tP"};